import React from 'react';

import { Select, Tag } from 'antd';
import { MAIL_ADDRESS_PATTERN } from 'src/constants';

type EmailsTagsProps = {
  id: string;
  placeholder: string;
  onChange: (emails: Array<string>) => void;
};

export const EmailsTags: React.FC<EmailsTagsProps> = ({
  id,
  placeholder,
  onChange,
}) => {
  const tagRender = (props: any) => {
    const { value, closable, onClose } = props;

    return value
      .trim()
      .split(/\s+/)
      .map((email: any) => (
        <Tag
          color={MAIL_ADDRESS_PATTERN.test(email) ? 'green' : 'red'}
          style={{ marginRight: 3 }}
          closable={closable}
          onClose={onClose}
        >
          {email}
        </Tag>
      ));
  };

  return (
    <Select
      id={id}
      mode="tags"
      style={{ width: '100%' }}
      dropdownStyle={{ display: 'none' }}
      tagRender={tagRender}
      onChange={(values: any) => {
        const emailsSplited: Array<string> = [];

        values.forEach((value: any) => {
          const emails = value.trim().split(/\s+/);

          emailsSplited.push(...emails);
        });

        onChange(emailsSplited);
      }}
      placeholder={placeholder}
    ></Select>
  );
};
